module.exports = __webpack_public_path__ + "img/parlamentarisch.f26f0a25.jpg";